module.exports = __webpack_public_path__ + "media/images/home/heart@2x-bd1cb52159a5b62aedb11fed87bd8606.png";